import { IS_IN_DEV } from "../flags";
const KEY = "multiplacer.dev.viewAs";
export type ViewAsUser = { id: string; name: string; email: string };
export function getViewAsUser(): ViewAsUser | null {
  if (!IS_IN_DEV) return null;
  try {
    const user = JSON.parse(sessionStorage.getItem(KEY) ?? "null");
    return user &&
      typeof user.id === "string" &&
      typeof user.name === "string" &&
      typeof user.email === "string"
      ? user
      : null;
  } catch {
    return null;
  }
}
export function viewAsHeaders(): Record<string, string> {
  const user = getViewAsUser();
  return user ? { "x-dev-view-as": user.id } : {};
}
export function switchViewAs(user: ViewAsUser | null) {
  if (!IS_IN_DEV) return;
  if (user) sessionStorage.setItem(KEY, JSON.stringify(user));
  else sessionStorage.removeItem(KEY);
  // Reset all Redux/API caches and return to the effective user's project list.
  window.location.assign("/");
}
